import React, { useState, useEffect } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import GeneralDetails from "../../components/Profile/GeneralDetails";
import UpdatePassword from "../../components/Profile/UpdatePassword";
import api from "../../config/apiConfig";
import { OFF_WHITE } from "../../constants/layout";

const DARK_NAVY = "#051525";
const DARK_NAVY_LIGHT = "#4a6278";
const TAB_BLUE = "#1E3A5F";
const PROFILE_FONT = '"Inter", sans-serif';

interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
}

const tabConfig = [
  {
    label: "Personal Info",
    title: "Personal Information",
    subtitle: "View and manage your profile, contact details, and verification",
  },
  {
    label: "Security",
    title: "Security",
    subtitle: "Choose a strong password to keep your account secure",
  },
];

function Profile() {
  const [value, setValue] = useState(0);
  const [user, setUser] = useState<User>();

  const fetchDetails = async () => {
    try {
      const accessToken = localStorage?.getItem("accessToken");
      const response = await api.post(
        "user/getById",
        {},
        { headers: { Authorization: accessToken } }
      );
      setUser(response?.data?.data[0]);
    } catch (error) {
      console.error("Failed to fetch user Details", error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const activeTab = tabConfig[value];

  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: OFF_WHITE,
        py: { xs: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1280,
          mx: "auto",
          px: { xs: 3, sm: 5, md: 8, lg: 10, xl: 12 },
          fontFamily: PROFILE_FONT,
        }}
      >
        <Tabs
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          sx={{
            mb: 3,
            minHeight: 40,
            "& .MuiTabs-indicator": {
              backgroundColor: TAB_BLUE,
              height: 2,
            },
            "& .MuiTab-root": {
              fontFamily: PROFILE_FONT,
              textTransform: "none",
              fontSize: 15,
              fontWeight: 500,
              color: DARK_NAVY_LIGHT,
              minHeight: 40,
              px: 2.5,
              mr: 1,
              "&.Mui-selected": {
                color: DARK_NAVY,
                fontWeight: 600,
              },
            },
          }}
        >
        {tabConfig.map((tab) => (
          <Tab key={tab.label} label={tab.label} />
        ))}
      </Tabs>

      <Typography
        sx={{
          fontFamily: PROFILE_FONT,
          fontSize: { xs: 26, md: 32 },
          fontWeight: 700,
          color: DARK_NAVY,
          lineHeight: 1.2,
          mb: 0.75,
        }}
      >
        {activeTab.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: PROFILE_FONT,
          fontSize: 14,
          color: DARK_NAVY_LIGHT,
          mb: 3,
        }}
      >
        {activeTab.subtitle}
      </Typography>

      {value === 0 && user && <GeneralDetails user={user} />}
      {value === 1 && <UpdatePassword />}
      </Box>
    </Box>
  );
}

export default Profile;
